import React from "react";
import { Box, Typography } from "@mui/material";
import I18n from "i18next";

import MzSwitch from "@markaaz/ui/MzSwitch";

const sx = {
  switchWrapper: {
    marginTop: "40px",
    display: "flex",
    gap: "50px"
  },
  switchItem: {
    minWidth: "150px",
    borderLeft: (theme) => `1px solid ${theme.palette.blue.c100}`,
    padding: "5px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "11px"
  },
  label: {
    color: "blue.c100",
    textTransform: "uppercase"
  },
  value: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "darkBlue.c100"
  },
  enabledDisabled: {
    color: "darkBlue.c100"
  }
};

export default function ReportFrequency({ isChecked, onChange, reportFrequency = "Monthly" }) {
  return (
    <Box sx={sx.switchWrapper}>
      <Box sx={sx.switchItem}>
        <Typography variant="overline1" sx={sx.label}>
          {I18n.t("monitoringConfiguration.monitoring")}
        </Typography>
        <Box sx={sx.value}>
          <MzSwitch checked={isChecked} onChange={onChange} />
          <Typography variant="body2" sx={sx.enabledDisabled}>
            {isChecked ? I18n.t("common.enabled") : I18n.t("common.disabled")}
          </Typography>
        </Box>
      </Box>
      <Box sx={sx.switchItem}>
        <Typography variant="overline1" sx={sx.label}>
          {I18n.t("monitoringConfiguration.reportFrequency")}
        </Typography>
        <Typography variant="body2" sx={sx.value}>
          {reportFrequency || I18n.t("monitoringConfiguration.monthly")}
        </Typography>
      </Box>
    </Box>
  );
}
